// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
header {
  color: #FF0000;
  background-image: linear-gradient(to right bottom, #55dce0, #00b7dc, #0090d6, #0066c5, #0036a2) !important;
}

.Navbar-title{
  color:#fff !important;
}
.QuickReply{
  background: #006ac7 !important;
  border-color: #006ac7 !important;
  font-weight: 500;
  color: #ffffff !important;
  box-shadow: 0 0 6px 0 #444;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
  border-radius: 0px !important;
  padding: 5px;
}
.QuickReply.highlight {
  background: #006ac7;
  border-color: #006ac7;
  font-weight: 500;
  color: #ffffff;
  box-shadow: 0 0 6px 0 #444;
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: fit-content;
    border-radius: 0px;
    padding: 5px;
  
}
.QuickReply .Icon {
  color: #22d50e !important;
  
}
.QuickReply.new:after {
  background: #fff !important;
}

.my-modal-container {
  max-width: 500px;
  width: 100%;
}

.my-modal-button {
  background-color: #4285f4;
  color: white;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  font-weight: bold;
}

.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-control:focus {
  outline: none;
  border-color: #4285f4;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.3);
}

.feedback-icons .Icon{
  margin: 5px;
  font-size: 25px;
}

.positive-feedback {
  color: green;
}

.negative-feedback {
  color: red;
}

/* .Btn{
  position: absolute;
  bottom: 150px;
  right: 100px;

  border-radius: 50%;
  border: none;
  padding: 10px;
  cursor: pointer;
  display: none;
  z-index: 1000;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.arrow path {
  fill: #007bff !important;
}
.chat-container {
  position: relative;
  display: flex;
  flex-direction: column;
}


.Btn.show{
  display: block;
}


.Btn:hover{
  background-color: #ffffff;
  transform: scale(1.1);
}
.Btn .arrow{
  fill: rgb(17, 17, 17);
  transition: transform 0.3s ease;
}
.Btn:hover .arrow {
  transform: rotate(180deg);
  animation: slide-in-bottom .7s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
} */

/* SEND BUTTON  */
.Btn--primary:not(.Btn--outline) {
background: #4285f4 !important;
bottom: auto;
text-shadow: black;
right: 20px;
}








`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,cAAc;EACd,0GAA0G;AAC5G;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;;AAEhB;AACA;EACE,yBAAyB;;AAE3B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyCG;;AAEH,iBAAiB;AACjB;AACA,8BAA8B;AAC9B,YAAY;AACZ,kBAAkB;AAClB,WAAW;AACX","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\nheader {\n  color: #FF0000;\n  background-image: linear-gradient(to right bottom, #55dce0, #00b7dc, #0090d6, #0066c5, #0036a2) !important;\n}\n\n.Navbar-title{\n  color:#fff !important;\n}\n.QuickReply{\n  background: #006ac7 !important;\n  border-color: #006ac7 !important;\n  font-weight: 500;\n  color: #ffffff !important;\n  box-shadow: 0 0 6px 0 #444;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: fit-content;\n  border-radius: 0px !important;\n  padding: 5px;\n}\n.QuickReply.highlight {\n  background: #006ac7;\n  border-color: #006ac7;\n  font-weight: 500;\n  color: #ffffff;\n  box-shadow: 0 0 6px 0 #444;\n  white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: fit-content;\n    border-radius: 0px;\n    padding: 5px;\n  \n}\n.QuickReply .Icon {\n  color: #22d50e !important;\n  \n}\n.QuickReply.new:after {\n  background: #fff !important;\n}\n\n.my-modal-container {\n  max-width: 500px;\n  width: 100%;\n}\n\n.my-modal-button {\n  background-color: #4285f4;\n  color: white;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\nlabel {\n  display: block;\n  font-weight: bold;\n}\n\n.form-control {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: #4285f4;\n  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.3);\n}\n\n.feedback-icons .Icon{\n  margin: 5px;\n  font-size: 25px;\n}\n\n.positive-feedback {\n  color: green;\n}\n\n.negative-feedback {\n  color: red;\n}\n\n/* .Btn{\n  position: absolute;\n  bottom: 150px;\n  right: 100px;\n\n  border-radius: 50%;\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  display: none;\n  z-index: 1000;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n.arrow path {\n  fill: #007bff !important;\n}\n.chat-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n\n.Btn.show{\n  display: block;\n}\n\n\n.Btn:hover{\n  background-color: #ffffff;\n  transform: scale(1.1);\n}\n.Btn .arrow{\n  fill: rgb(17, 17, 17);\n  transition: transform 0.3s ease;\n}\n.Btn:hover .arrow {\n  transform: rotate(180deg);\n  animation: slide-in-bottom .7s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n} */\n\n/* SEND BUTTON  */\n.Btn--primary:not(.Btn--outline) {\nbackground: #4285f4 !important;\nbottom: auto;\ntext-shadow: black;\nright: 20px;\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
